import { theme } from '@prophecy/theme';
import { Dialog } from '@prophecy/ui-v3';
import { StyledChildrenWrap, StyledContent } from '@prophecy/ui-v3/Dialog/styled';
import styled from 'styled-components';

export const TermsScrollFrame = styled.div<{ $showTopFade: boolean; $showBottomFade: boolean }>`
  position: relative;

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 1px;
    right: ${theme.spaces.x12};
    height: ${theme.sizes.x48};
    pointer-events: none;
    transition: opacity 0.15s ease-in-out;
  }

  &::before {
    top: 1px;
    border-radius: ${theme.radius.x8} ${theme.radius.x8} 0 0;
    background: linear-gradient(to bottom, ${theme.colors.gray25}, transparent);
    opacity: ${({ $showTopFade }) => ($showTopFade ? 1 : 0)};
  }

  &::after {
    bottom: 1px;
    border-radius: 0 0 ${theme.radius.x8} ${theme.radius.x8};
    background: linear-gradient(to top, ${theme.colors.gray25}, transparent);
    opacity: ${({ $showBottomFade }) => ($showBottomFade ? 1 : 0)};
  }
`;

export const TermsScrollArea = styled.div`
  height: ${theme.width.x320};
  overflow-y: auto;
  padding: ${theme.spaces.x16} ${theme.spaces.x20};
  border: 1px solid ${theme.colors.gray200};
  border-radius: ${theme.radius.x8};
  background: ${theme.colors.gray25};
`;

export const StyledSapAiTermsDialog = styled(Dialog)`
  && {
    width: ${theme.width.x640};
    outline: none;
  }

  && ${StyledContent}, && ${StyledChildrenWrap}, && ${TermsScrollArea} {
    outline: none;
    box-shadow: none;
  }
`;

export const RecordNote = styled.div`
  padding-left: ${theme.spaces.x24};
`;

export const EndOfTermsMarker = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${theme.spaces.x8};
`;

export const ScrollMarker = styled.div`
  height: 1px;
`;
